export default "__VITE_ASSET__BQ_XKiqU__"